module.exports = __webpack_public_path__ + "static/img/image9.346fd41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/image9.png
// module id = UvSS
// module chunks = 14